import { render, staticRenderFns } from "./agr_pro_details.vue?vue&type=template&id=2e5380d4&"
import script from "./agr_pro_details.vue?vue&type=script&lang=js&"
export * from "./agr_pro_details.vue?vue&type=script&lang=js&"
import style0 from "./agr_pro_details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports